// TODO: Remove field specific validation from this generic file.
import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Button,
  Stack,
  InputLabel,
  Card,
  CardContent,
  Box,
  Grid,
  Alert,
} from "@mui/material";
import { RenderField } from "./Field";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { getCurrentDate } from "../lib/time";
import { useGetProjectsAll } from "../features/projects/hooks";

export const Form = (props: any) => {
  const {
    fields,
    onSubmit,
    onSave = null,
    record = {},
    options = [],
    onFormDataChange,
    externalError = null,
    submitLabel = "Save",
    formError = "", 
    formIsValid 
  } = props;
  const [formData, setFormData] = useState<any | undefined>(record);
  const [message, setMessage] = useState<any | undefined>("");
  const [emailError, setEmailError] = useState<any | undefined>(false);
  const [timeError, setTimeError] = useState<any | undefined>("");
  const [projectData, setProjectData] = useState<any | undefined>([]);
  const [isProjectExit, setIsProjectExit] = useState<any | undefined>(false);
  const navigate = useNavigate();
  const scrollRef = useRef<HTMLDivElement | null>(null);
  let timeFieldNames: String[] = [];

  const { data: projects } = useGetProjectsAll("projects");
  const submitHandler = (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(formData);
  };

  const onDataEntry = (
    event?: React.ChangeEvent<HTMLInputElement> | any,
    fieldName?: {
      fieldType: string;
      name: string;
      label: string;
      errorMessage: string;
      isRequired: boolean;
      options: any[];
      rules: any | null;
      fullWidth: boolean;
    }
  ) => {
    console.log('data entry',fieldName)
    let updateData = {};
    if (event?.hasOwnProperty("target")) {
      
      if (fieldName?.label === "T&M Name" && event.target.value.length > 50) {
        event.target.value = event.target.value.slice(0, 50);
      }
      if (fields[7]?.name == "changeEvent" && event.target.value.length > 15) {
        event.target.value = event.target.value.slice(0, 15);
      }
      if (fieldName?.name === "projectName") {
        const comparedData = projectData?.includes(event.target.value);
        setIsProjectExit(comparedData);
      }
      updateData = { ...formData, [event.target.name]: event.target.value };
      setFormData(updateData);  
    } else if (dayjs(event).isValid() && fieldName?.name) {
      // Handle date/time fields
      updateData = { ...formData, [fieldName.name]: event };
      setFormData(updateData);
  
    } else {
      updateData = { ...formData, [event?.name]: event?.value };
      setFormData(updateData);
    }
    // Handle default value for 'dailyGraceTime' when the field is cleared
    if (fieldName?.name === "dailyGraceTime" && event?.target?.value === "") {
      updateData = { ...formData, [fieldName.name]: formData.dailyGraceTime };
      setFormData(updateData);
    }
    if (onFormDataChange) {
      onFormDataChange(updateData);
    }
  };

  const onCompositeFieldChange = (value: any, fieldName: string) => {
    if (
      Array.isArray(value) &&
      value.length === 1 &&
      value[0].hasOwnProperty("lineItemValue") &&
      value[0].lineItemValue === ""
    ) {
      // Remove any empty objects from array
      value = [];
    }
    setFormData({ ...formData, [fieldName]: value });
    if (onFormDataChange) {
      onFormDataChange({ ...formData, [fieldName]: value });
    }
  };

  const renderFieldValue = (field: any) => {
    switch (field.fieldType) {
      case "time":
        // Keep track of time fields to format on submission
        if (!timeFieldNames.includes(field.name)) {
          timeFieldNames.push(field.name);
        }
        // Time field requires a date
        formData[field.name] = formData[field.name]
          ? formData[field.name]
          : getCurrentDate() + " " + field.defaultValue;
        return formData[field.name]
          ? formData[field.name]
          : getCurrentDate() + " " + field.defaultValue;
      case "number":
        // Display placeholder for number fields if the value is cleared
        return formData[field.name] !== undefined
          ? formData[field.name]
          : field.defaultValue !== undefined
          ? field.defaultValue
          : "";
      default:
        if (!formData[field.name] && field.defaultValue) {
          formData[field.name] = field.defaultValue;
        }
        return formData[field.name];
    }
  };
  const handlePrjoectName = useCallback(() => {
    if (fields[0]?.name === "projectName") {
      const data = projects && projects?.map((item: any) => item?.projectName);
      setProjectData(data);
    }
  }, [fields, projects]);

  useEffect(() => {
    handlePrjoectName();
  }, [handlePrjoectName]);

  useEffect(() => {
    if (record) {
      setFormData(record);
    }
  }, [record]);

  return (
    <>
      <div style={{ height: "100%" }}>
        <form onSubmit={submitHandler}>
          <Box>
            {externalError && (
              <Alert severity="error" sx={{ marginBottom: 2 }}>
                {externalError}
              </Alert>
            )}
            {formError && (
              <Alert severity="error" sx={{ marginBottom: 2 }}>
                {formError}
              </Alert>
            )}
            {fields[0]?.name == "projectName" && isProjectExit && (
              <Alert severity="error" sx={{ marginBottom: 2 }}>
                Project with the same name already exists
              </Alert>
            )}
          </Box>
          <Box  sx={{ marginBottom: 3 }}>
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                padding: 2,
                boxShadow: "0px 2px 4px 0px #0000000D",
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2}>
                {fields &&
                  fields.map((field: any, key: any) => (
                    <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={
                      field.hasOwnProperty("layout") &&
                      field.layout === "inline"
                        ? 6
                        : 12
                    }
                    key={key}
                    style={{marginTop:0,paddingTop:0,marginBottom:0,paddingBottom:0}}
                  >
                      <Box
                        key={key}
                        className="formfield"
                        ref={field.name === "clientEmails" ? scrollRef : null}
                      >
                        <InputLabel>{field.label}</InputLabel>
                        {field.name === "location"
                          ? RenderField(
                              field,
                              key,
                              (event: any) => onDataEntry(event, field),
                              formData["locations"],
                              [],
                              props.children,
                            )
                          : RenderField(
                              field,
                              key,
                              (event: any) => onDataEntry(event, field),
                              renderFieldValue(field),
                              options,
                              props.children,
                              onCompositeFieldChange,
                            )}
                        <p style={{ color: "red" }}>
                          {" "}
                          {field.name == "clientEmails"
                            ? emailError
                              ? message
                              : ""
                            : null}
                        </p>
                        {field.fieldType == "time" && (
                          <p style={{ color: "red" }}>{timeError}</p>
                        )}
                      </Box>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </Box>
          <Stack spacing={2} direction="row">
            {onSave && (
              <Button variant="contained" onClick={onSave}>
                Save Draft
              </Button>
            )}
            <Button
              type="submit"
              variant="contained"
              disabled={!!externalError || isProjectExit || formIsValid}
            >
              {submitLabel}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
          </Stack>
        </form>
      </div>
    </>
  );
};
